import React from "react";
import {Dropdown} from "react-bootstrap";
import {withNamespaces} from "react-i18next";

const UserInfo = ({t, user, goToSettings, logout}) => {
    return (
        <Dropdown id="dropdown-user" className="btn" >
            <Dropdown.Toggle variant=""  >
                <div className="account-user d-flex align-items-center text-left">
                    <i className="d-flex fas fa-2x fa-user-circle"> </i>
                    <div className="user-info d-flex flex-column ml-2">
                        { !user.Name || !user.Lastname || (
                            <span className="account-name"> { user.Name + " " + user.Lastname }  </span>
                        ) }
                        <span className="account-email"> { user.Email ? user.Email : user.Username } </span>
                    </div>
                </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="menu-account">
                <Dropdown.Item onClick={goToSettings}>
                    <i className="fas fa-user-cog"> </i> &nbsp;
                    <span> { t('settings') } </span>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={logout}>
                    <i className="fas fa-sign-out-alt"> </i> &nbsp;
                    <span> { t('logout') } </span>
                </Dropdown.Item>
            </Dropdown.Menu>

        </Dropdown>
    )
}
export default withNamespaces()(UserInfo);